<div
  [class]="typologies"
  class="hb-group:tw-text-midnight-green mb-group:connected:tw-text-eerie-black"
>
  <router-outlet />
</div>
